/** kept out of ./selectors to avoid circular dependency with offerCheck module */
import {getOfferCheckError} from 'modules/offerCheck/selectors'
import {anyPass, curry, path, propOr} from 'ramda'
import {RootState} from 'store'
import {CommonErrorPayloadFormatType} from 'types/errorResponse'

import {Category as ErrorCategory} from '@vio/core/src/api-types/bovio/response/error'
import {
  getIsCardNotSupported,
  getIsConnectionError,
  getIsDuplicateBooking,
  getIsGenericFraudDeclined,
  getIsGenericPaymentDeclined,
  getIsGenericSupplierOrBackendError,
  getIsInsufficientFunds,
  getIsInvalidEmail,
  getIsPriceMismatch,
  getIsWrongCCError,
  getIsWrongCVCError
} from '@vio/core/src/booking/utils/bookingErrorHelpers'

import {
  BOOKING_PRESENTER_ERRORS,
  PRESENTER_TYPES,
  PresenterTypesType
} from './constants'

const testNewArchitectureErrors = anyPass([
  getIsWrongCVCError,
  getIsWrongCCError,
  getIsGenericPaymentDeclined,
  getIsGenericFraudDeclined,
  getIsInsufficientFunds,
  getIsInvalidEmail,
  getIsCardNotSupported,
  getIsGenericSupplierOrBackendError,
  getIsConnectionError,
  getIsDuplicateBooking,
  getIsPriceMismatch
])

const getPresenterID = (error?: CommonErrorPayloadFormatType | null) => {
  switch (error?.errorResponse?.type) {
    case 'provider':
    case 'provider_booking_creation':
    case 'provider_pre_book': {
      return propOr(
        PRESENTER_TYPES.GenericError,
        error?.errorResponse?.details?.category as ErrorCategory,
        BOOKING_PRESENTER_ERRORS
      )
    }

    case 'booking_unauthorized': {
      return propOr(
        PRESENTER_TYPES.UnauthorizedBookingError,
        error?.errorResponse?.details?.category as ErrorCategory,
        BOOKING_PRESENTER_ERRORS
      )
    }

    case 'input_validation': {
      return propOr(
        PRESENTER_TYPES.GenericError,
        error.errorResponse.type,
        BOOKING_PRESENTER_ERRORS
      )
    }

    case 'pci_proxy': {
      return PRESENTER_TYPES.PopUpPaymentError
    }

    case 'fatal': {
      return PRESENTER_TYPES.GenericError
    }

    default: {
      return propOr(
        PRESENTER_TYPES.GenericError,
        error?.errorResponse?.details?.category as ErrorCategory,
        BOOKING_PRESENTER_ERRORS
      )
    }
  }
}

const hasBackendResponse = (state: RootState) =>
  Boolean(path(['common', 'error', 'errorResponse'], state))

// @Todo - Refactor it after website-2 since now on B side we have
// just one presenter for all Overlay Errors
export const getErrorByPresenterType = curry(
  (presenter: PresenterTypesType, state: RootState) => {
    if (hasBackendResponse(state)) {
      /**
       * Bypass to show the popup error for new error UI
       */
      if (
        !getOfferCheckError(state) &&
        testNewArchitectureErrors({
          data: state.common.error?.errorResponse,
          status: state.common.error?.statusCode
        })
      ) {
        return undefined
      }

      const currentPresenter = getPresenterID(state.common.error)
      if (currentPresenter === presenter) {
        return state.common.error
      }
    }
  }
)
